/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { ReactNode } from "react";
import LoadingIndicatorSuspense from "../LoadingIndicatorSuspense";
import LoadingIndicator from "./../LoadingIndicator/";
import "./ViewMainContent.scss";

export interface ViewMainContentProps {
    children?: ReactNode;
    className?: string;
    loading?: boolean;
}

export default function ViewMainContent({ children, className, loading }: ViewMainContentProps) {
    return (
        <LoadingIndicatorSuspense>
            <div className={`lan-viewmaincontent ${className ?? ""}`}>
                <LoadingIndicator loading={loading ?? false}>{children}</LoadingIndicator>
            </div>
        </LoadingIndicatorSuspense>
    );
}
